import React from 'react';
import { resolveAssetUrl } from '../../../../../modules/assets';
import styles from './styles.scss';

const propTypes = {};

const defaultProps = {};

const Icon = () => (
  <img src={resolveAssetUrl('/img/pop-up-icon.svg')} className={styles.icon} alt="popup" />
);

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default Icon;
